import MainRouter from "./_routers/Router";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
// import useDevToolsBlocker from "./_hooks/useDevToolsBlocker";

function App() {
  // useDevToolsBlocker()
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <ToastContainer />
      <MainRouter />
    </>
  );
}

export default App;
